import { types, helpers } from 'utilities';
import { 
  DEFAULT_API_RESULT
} from './../variables';

import { EXP_LAMBDA_API_URL } from 'index'

export const adminGetProducts = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/admin/products', {
      method: 'GET',
      // body: JSON.stringify(query.body)
    });
    
    if(response.status !== 200 ){
      throw new Error(`GET Products HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET Products Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const adminGetProduct = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/admin/products/${query.body.id}`, {
      method: 'GET',
    });

    if(response.status !== 200 ){
      throw new Error(`GET Admin Product HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET Admin Product Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const adminGetNumbers = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/admin/numbers', {
      method: 'GET',
      // body: JSON.stringify(query.body)
    });
    
    if(response.status !== 200 ){
      throw new Error(`adminGetNumbers GET Numbers HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      helpers.logToOutput('adminGetNumbers GET Numbers response', responseJson);
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('adminGetNumbers GET Numbers Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getUserNumbers = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/numbers', {
      method: 'GET',
      // body: JSON.stringify(query.body)
    });
    
    if(response.status !== 200 ){
      throw new Error(`getUserNumbers GET Numbers HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      helpers.logToOutput('getUserNumbers GET Numbers response', responseJson);
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('getUserNumbers GET Numbers Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const  createNumber  = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    helpers.logToOutput('API: createNumber: POST: BODY: ', query)
    
    const response = await fetch(EXP_LAMBDA_API_URL + '/numbers', {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('API: createNumber: POST: ', response)
  
    if(response.status !== 200 ){
      throw new Error(`POST: createNumber: HTTP error! Status: ${response.status}`);
    } else {
        
      const responseJson = await response.json();
      helpers.logToOutput('API: createNumber: POST[JSON]: ', responseJson)
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: createNumber: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const  createEdge  = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    helpers.logToOutput('API: createEdge: POST: BODY: ', query)
    
    const response = await fetch(EXP_LAMBDA_API_URL + '/mobilegateway/relaynodes/create', {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('API: createEdge: POST: ', response)
  
    if(response.status !== 200 ){
      throw new Error(`POST: createEdge: HTTP error! Status: ${response.status}`);
    } else {
        
      const responseJson = await response.json();
      helpers.logToOutput('API: createEdge: POST[JSON]: ', responseJson)
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: createEdge: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}


export const adminGetEdges = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/mobilegateway/relaynodes', {
      method: 'GET',
      // body: JSON.stringify(query.body)
    });
    
    if(response.status !== 200 ){
      throw new Error(`GET Edges HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET Edges Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const adminGetMessages = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/admin/messages', {
      method: 'GET',
      // body: JSON.stringify(query.body)
    });
    
    if(response.status !== 200 ){
      throw new Error(`GET Messages HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET Messages Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const adminGetProviders = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/admin/providers', {
      method: 'GET',
      // body: JSON.stringify(query.body)
    });
    
    if(response.status !== 200 ){
      throw new Error(`GET Providers HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET Providers Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const adminGetProviderDetails = async(query: any) => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/admin/provider/${query.id}`, {
      method: 'GET'
    });
    
    if(response.status !== 200 ){
      throw new Error(`GET adminGetProviderDetails HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET adminGetProviderDetails Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const adminRefreshProvider = async(query: any) => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/admin/provider/refresh/${query.id}`, {
      method: 'GET'
    });
    
    if(response.status !== 200 ){
      throw new Error(`GET adminRefreshProvider HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      helpers.logToOutput('adminRefreshProvider GET response', responseJson);
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET adminRefreshProvider Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const adminPutProvider = async(query: any) => {
  
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/admin/provider/${query.id}`, {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('adminPutProviders response:', response);

    if (!response.ok) {
      throw new Error(`adminPutProviders HTTP error! Status: ${response.status}`);
    }

    //const responseJson = await response.json();
    return response

  } catch (error: any) {
    helpers.logToOutput('adminPutProviders Error', error.message); // Setting the error state if there's an error
    
  }
  
}

export const adminPutVPNDetails = async(query: any) => {
  
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/admin/vpn/ovpn/all', {
      method: 'POST',
      body: JSON.stringify(query.body.vpn_details)
    });

    helpers.logToOutput('adminPutVPNDetails response:', response);

    if (!response.ok) {
      throw new Error(`adminPutVPNDetails HTTP error! Status: ${response.status}`);
    }

    const responseJson = await response.json();
    return responseJson

  } catch (error: any) {
    helpers.logToOutput('adminPutVPNDetails Error', error.message); // Setting the error state if there's an error
    
  }
  
}

export const adminGetVPNDetails = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/admin/vpn/ovpn/all', {
      method: 'GET',
      // body: JSON.stringify(query.body)
    });
    
    if(response.status !== 200 ){
      throw new Error(`adminGetVPNDetails GET HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson.response
      }
    }
  } catch (error: any) {
    helpers.logToOutput('adminGetVPNDetails GET Error', error.message);
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const adminGetNumber = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/admin/numbers/${query.body.id}`, {
      method: 'GET',
    });

    if(response.status !== 200 ){
      throw new Error(`GET Admin Number HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET Admin Number Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const adminPutNumber = async(query: any) => {
  
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/numbers/${query.id}`, {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('adminPutNumber response:', response);

    if (!response.ok) {
      throw new Error(`adminPutNumber HTTP error! Status: ${response.status}`);
    }

    //const responseJson = await response.json();
    return response

  } catch (error: any) {
    helpers.logToOutput('adminPutNumber Error', error.message); // Setting the error state if there's an error
    
  }
  
}

export const putUpdateNumber = async(query: any) => {
  
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/numbers/${query.id}`, {
      method: 'PUT',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('putUpdateNumber response:', response);

    if (!response.ok) {
      throw new Error(`putUpdateNumber HTTP error! Status: ${response.status}`);
    }

    //const responseJson = await response.json();
    return response

  } catch (error: any) {
    helpers.logToOutput('putUpdateNumber Error', error.message); // Setting the error state if there's an error
    
  }
  
}

export const getProducts = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/products', {
      method: 'GET',
      // body: JSON.stringify(query.body)
    });
    
    if(response.status !== 200 ){
      throw new Error(`GET Products HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET Products Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getProduct = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.body.id}`, {
      method: 'GET',
    });

    if(response.status !== 200 ){
      throw new Error(`GET Product HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET Product Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getProductMessages = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/messages`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (response.status !== 200) {
      throw new Error(`getProductMessages HTTP error! Status: ${response.status}`);
    } else {
      const responseJson = await response.json();
      //helpers.logToOutput('getProductMessages  responseJson:', responseJson);
      const responseObj = responseJson.parameter_value;
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: { responseObj }
      }
    }

  } catch (error: any) {
    helpers.logToOutput('getProductMessages Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error.message
    }
  }
}

export const getProductNumber = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/number`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (response.status !== 200) {
      throw new Error(`getProductNumber HTTP error! Status: ${response.status}`);
    } else {
      const responseJson = await response.json();
      
      const responseObj = responseJson.parameter_value;
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: { responseObj }
      }
    }

  } catch (error: any) {
    //helpers.logToOutput('getProductNumber Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error.message
    }
  }
}

export const getNumbers = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/numbers', {
      method: 'GET',
      // body: JSON.stringify(query.body)
    });
    
    if(response.status !== 200 ){
      throw new Error(`GET Numbers HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET Numbers Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getNumber = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/numbers/${query.body.id}`, {
      method: 'GET',
    });

    if(response.status !== 200 ){
      throw new Error(`GET Number HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET Number Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getRegions = async(): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/regions', {
      method: 'GET',
    });

    if(response.status !== 200 ){
      throw new Error(`GET Product HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET Product Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const postChatMessages = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(query.url, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(query.body.payload)
    });

    helpers.logToOutput('POST CHAT response json', response);

    if(response.status !== 200 ){
      throw new Error(`POST CHAT HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();

      helpers.logToOutput('POST CHAT response json', responseJson);
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST CHAT Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const createPaymentIntent = async(query: any) : Promise<types.IApiHandledResponse> => {

  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/pay', {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    if(response.status !== 200 ){
      throw new Error(`POST Payment Intent HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST Payment Intent', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const createEnterpriseProduct = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    helpers.logToOutput('Enterprise Create: Sending API Request...')
    helpers.logToOutput('Enterprise Create: Query : ', query)
    const response = await fetch(EXP_LAMBDA_API_URL + '/products', {
      method: 'PUT',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('PUT: Enterprise Product: Response : ', response);

    const responseJson = await response.json();

    if(response.status !== 200 ){
      helpers.logToOutput('PUT: RES: RES: RES', response);
      helpers.logToOutput('PUT: RES: RES: RES', responseJson);

      //throw new Error(`PUT: Enterprise Product: HTTP error! Status: ${response.status}`);

      return {
        status: DEFAULT_API_RESULT.FAILURE,
        body: responseJson
      }

    } else {
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
    
  } catch (error: any) {
    helpers.logToOutput('PUT: Enterprise Product: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const deleteProduct = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.body.id}`, {
      method: 'DELETE',
      body: JSON.stringify({})
    });

    if(response.status !== 200 ){
      throw new Error(`DELETE: Product: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('DELETE: Product: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const startProduct = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.body.id}/start`, {
      method: 'POST',
      body: JSON.stringify({})
    });

    if(response.status !== 200 ){
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.FAILURE,
        body: {responseJson}
      }
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: ProductStart:', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const hibernateProduct = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.body.id}/hibernate`, {
      method: 'POST',
      body: JSON.stringify({})
    });

    if(response.status !== 200 ){
      throw new Error(`POST: ProductHibernate: HTTP error! Status: ${response.status}`);
    } else {
      helpers.logToOutput('POST: ProductHibernate: Success : ', response);
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: ProductHibernate: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const resetProduct = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    const response = await fetch(EXP_LAMBDA_API_URL + `/admin/products/${query.body.id}/reset`, {
      method: 'POST',
      body: JSON.stringify({})
    });

    if(response.status !== 200 ){
      throw new Error(`POST: ProductReset: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: ProductReset: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const stopProduct = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.body.id}/stop`, {
      method: 'POST',
      body: JSON.stringify({})
    });

    if(response.status !== 200 ){
      throw new Error(`POST: ProductStop: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: ProductStop: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getpresignedLink = async(query: any) => {
  
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/presign`, {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('presignProductLink response:', response);

    if (!response.ok) {
      throw new Error(`presignProductLink HTTP error! Status: ${response.status}`);
    }

    const responseJson = await response.json();
    return {
      status: DEFAULT_API_RESULT.SUCCESS,
      body: responseJson
    }

  } catch (error: any) {
    helpers.logToOutput('presignProductLink Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getProductPresignedLink = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/presign`, {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('presignProductLink response:', response);

    if (response.status !== 200) {
      throw new Error(`presignProductLink HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();

      helpers.logToOutput('presignProductLink ResponseJson', responseJson);
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }

  } catch (error: any) {
    helpers.logToOutput('presignProductLink Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
  
}

export const getProductPresignedLinks = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/presign`, {
      method: 'GET',
    });

    helpers.logToOutput('presignProductLink response:', response);

    if (response.status !== 200) {
      throw new Error(`presignProductLink HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();

      helpers.logToOutput('presignProductLink ResponseJson', responseJson);
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }

  } catch (error: any) {
    helpers.logToOutput('presignProductLink Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getDomains = async(): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/domains', {
      method: 'GET',
    });

    helpers.logToOutput('getDomains response:', response);

    if (response.status !== 200) {
      throw new Error(`getDomains HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();

      helpers.logToOutput('getDomains ResponseJson', responseJson);
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }

  } catch (error: any) {
    helpers.logToOutput('getDomains Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const deletePresignedLink = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/presign/${query.id}`, {
      method: 'DELETE',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('deletePresignedLink response:', response);

    if (response.status !== 200) {
      throw new Error(`deletePresignedLink HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();

      helpers.logToOutput('deletePresignedLink ResponseJson', responseJson);
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }

  } catch (error: any) {
    helpers.logToOutput('presignProductLink Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
  
}

export const getProductEncryptedCredentials = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    // Generate RSA key pair
    const keyPair = await window.crypto.subtle.generateKey(
      {
        name: 'RSA-OAEP',
        modulusLength: 2048, // 2048-bit key
        publicExponent: new Uint8Array([1, 0, 1]), // 65537
        hash: 'SHA-256',
      },
      true, // Whether the key is extractable (i.e., can be used in exportKey)
      ['encrypt', 'decrypt']
    );

    // Export the public key to send it to the API
    const publicKey = await window.crypto.subtle.exportKey(
      'spki', 
      keyPair.publicKey
    );

    // Convert publicKey to a format that can be sent in a JSON object (Base64)
    const publicKeyBase64 = btoa(String.fromCharCode(...Array.from(new Uint8Array(publicKey))));


    // Include the public key in the body of the POST request
    const requestBody = {
      ...query.body,
      publicKey: publicKeyBase64
    };

    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    helpers.logToOutput('presignProductLink response:', response);

    if (response.status !== 200) {
      throw new Error(`presignProductLink HTTP error! Status: ${response.status}`);
    } else {
      const responseJson = await response.json();

      // Decrypt the password using the private key
      const encryptedPassword = Uint8Array.from(atob(responseJson.encryptedPassword), c => c.charCodeAt(0));

      const decryptedPassword = await window.crypto.subtle.decrypt(
        {
          name: 'RSA-OAEP',
        },
        keyPair.privateKey,
        encryptedPassword
      );

      // Convert decryptedPassword from ArrayBuffer to string
      const decoder = new TextDecoder();
      const password = decoder.decode(decryptedPassword);

      helpers.logToOutput('presignProductLink decrypted password:', password);

      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: { password }
      }
    }

  } catch (error: any) {
    helpers.logToOutput('presignProductLink Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error.message
    }
  }
}

export const getProductCredentials = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    // Generate RSA key pair
    
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/password`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (response.status !== 200) {
      throw new Error(`getProductCredentials HTTP error! Status: ${response.status}`);
    } else {
      const responseJson = await response.json();
      helpers.logToOutput('getProductCredentials  password:', responseJson.parameter_value);
      const responseObj = JSON.parse(responseJson.parameter_value);
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: { responseObj }
      }
    }

  } catch (error: any) {
    helpers.logToOutput('getProductCredentials Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error.message
    }
  }
}

export const getReferences = async(query: any): Promise<types.IApiHandledResponse> => {
  try {

    const response = await fetch(EXP_LAMBDA_API_URL + `/data/references/${query.body.type}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (response.status !== 200) {
      throw new Error(`getReferences HTTP error! Status: ${response.status}`);
    } else {
      const responseJson = await response.json();
      helpers.logToOutput('getReferences  responseJson]:', responseJson);
      const responseObj = responseJson.parameter_value;
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: { responseObj }
      }
    }

  } catch (error: any) {
    helpers.logToOutput('getReferences Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error.message
    }
  }
}

export const getReference = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/data/reference/${query.body.id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (response.status !== 200) {
      throw new Error(`getReference HTTP error! Status: ${response.status}`);
    } else {
      const responseJson = await response.json();
      helpers.logToOutput('getReference  responseJson]:', responseJson);
      const responseObj = responseJson.parameter_value;
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: { responseObj }
      }
    }

  } catch (error: any) {
    helpers.logToOutput('getReference Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error.message
    }
  }
}

export const getMetadata = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/data/meta/${query.body.metatype}/${query.body.metasubtype}/${query.id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (response.status !== 200) {
      throw new Error(`getMetadata HTTP error! Status: ${response.status}`);
    } else {
      const responseJson = await response.json();
      helpers.logToOutput('getMetadata  responseJson]:', responseJson);
      const responseObj = responseJson.parameter_value;
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: { responseObj }
      }
    }

  } catch (error: any) {
    helpers.logToOutput('getMetadata Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error.message
    }
  }
}

export const getProductMeta = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/meta/${query.body.key}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (response.status !== 200) {
      throw new Error(`getProductMeta HTTP error! Status: ${response.status}`);
    } else {
      const responseJson = await response.json();
      helpers.logToOutput('getProductMeta  responseJson]:', responseJson);
      const responseObj = responseJson.parameter_value;
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: { responseObj }
      }
    }

  } catch (error: any) {
    helpers.logToOutput('getProductMeta Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error.message
    }
  }
}

export const putProductMeta = async(query: any) => {
  
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/meta`, {
      method: 'PUT',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('putProductMeta response:', response);

    if (!response.ok) {
      throw new Error(`putProductMeta HTTP error! Status: ${response.status}`);
    }

    //const responseJson = await response.json();
    return response

  } catch (error: any) {
    helpers.logToOutput('putProductMeta Error', error.message); // Setting the error state if there's an error
    
  }
  
}

export const putProductHibernation = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/meta`, {
      method: 'PUT',
      body: JSON.stringify(query.body)
    });

    if(response.status !== 200 ){
      throw new Error(`PUT: putProductHibernation: HTTP error! Status: ${response.status}`);
    } else {
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('PUT: putProductHibernation: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const putProductPaste = async(query: any) => {
  
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/copypaste`, {
      method: 'PUT',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('putProductPaste response:', response);

    if (!response.ok) {
      helpers.logToOutput(`putProductPaste HTTP error! Status: ${response.status}`);
    }

    const responseJson = await response.json();
    helpers.logToOutput('putProductPaste response:', response);
    helpers.logToOutput('putProductPaste responseJson:', responseJson);
    return responseJson

  } catch (error: any) {
    helpers.logToOutput('putProductPaste Error', error.message); // Setting the error state if there's an error
  }
}

export const getShareProductUser = async(query: any) => {
  
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/users`, {
      method: 'GET'
      //body: JSON.stringify(query.body)
    });

    helpers.logToOutput('getShareProductUser response:', response);

    if (!response.ok) {
      throw new Error(`getShareProductUser HTTP error! Status: ${response.status}`);
    }

    const responseJson = await response.json();
    return responseJson

  } catch (error: any) {
    helpers.logToOutput('getShareProductUser Error', error.message); // Setting the error state if there's an error
  }
  
}

export const putShareProductUser = async(query: any) => {
  
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/share`, {
      method: 'PUT',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('putShareProductUser response:', response);

    //if (!response.ok) {
    //  throw new Error(`putShareProductUser HTTP error! Status: ${response.status}`);
    //}

    const responseJson = await response.json();
    helpers.logToOutput('putShareProductUser response:', response);
    helpers.logToOutput('putShareProductUser responseJson:', responseJson);
    return responseJson

  } catch (error: any) {
    helpers.logToOutput('putShareProductUser Error', error.message); // Setting the error state if there's an error
  }
  
}

export const putShareProductGroup = async(query: any) => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/sharegroup`, {
      method: 'PUT',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('putShareProductGroup response:', response);

    //if (!response.ok) {
    //  throw new Error(`putShareProductGroup HTTP error! Status: ${response.status}`);
    //}

    const responseJson = await response.json();
    helpers.logToOutput('putShareProductGroup response:', response);
    helpers.logToOutput('putShareProductGroup responseJson:', responseJson);
    return responseJson

  } catch (error: any) {
    helpers.logToOutput('putShareProductGroup Error', error.message); // Setting the error state if there's an error
  }
}

export const delShareProductGroup = async(query: any) => {
  
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/sharegroup`, {
      method: 'DELETE',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('delShareProduct response:', response);

    //if (!response.ok) {
    //  throw new Error(`delShareProduct HTTP error! Status: ${response.status}`);
    //}

    const responseJson = await response.json();
    helpers.logToOutput('delShareProduct return', responseJson)
    return responseJson

  } catch (error: any) {
    helpers.logToOutput('delShareProduct Error', error.message); // Setting the error state if there's an error
    return error
  }
  
}

export const delShareProductUser = async(query: any) => {
  
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/share`, {
      method: 'DELETE',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('delShareProductUser response:', response);

    //if (!response.ok) {
    //  throw new Error(`delShareProductUser HTTP error! Status: ${response.status}`);
    //}

    const responseJson = await response.json();
    helpers.logToOutput('delShareProductUser return', responseJson)
    return responseJson

  } catch (error: any) {
    helpers.logToOutput('delShareProductUser Error', error.message); // Setting the error state if there's an error
    return error
  }
  
}

export const setUserAttributes = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    /**
   * TO-DO:
   * - Check with API docs and update to work with UI
   * - can accept user's name, photo, etc
   */
    const response = await fetch(EXP_LAMBDA_API_URL + `/users/${query.body.id}`, {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    if(response.status !== 200 ){
      throw new Error(`POST: ProfileUpdate: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: ProfileUpdate: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getUserAttributes = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    /**
   * TO-DO:
   * - Check with API docs and update to work with UI
   * - can accept user's name, photo, etc
   */
    const response = await fetch(EXP_LAMBDA_API_URL + `/users/${query.body.id}`, {
      method: 'GET',
    });

    if(response.status !== 200 ){
      throw new Error(`GET: UserAttributes: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET: UserAttributes: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getProfilePhoto = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
  
    /**
   * TO-DO:
   * - Check with API docs and update to work with UI
   * - can accept user's name, photo, etc
   */
    const response = await fetch(EXP_LAMBDA_API_URL + '/users/profile/photo', {
      method: 'GET',
      
    });

    if(response.status !== 200 ){
      throw new Error(`GET: ProfilePhoto: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('PATCH: ProfileUpdate: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const setProfilePhoto = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    /**
   * TO-DO:
   * - Check with API docs and update to work with UI
   * - can accept user's name, photo, etc
   */
    const response = await fetch(EXP_LAMBDA_API_URL + '/users/profile/photo', {
      method: 'PUT',
      body: JSON.stringify(query.contentBinary),
      headers: {
        'Content-Type': query.contentType,
        'Content-Length': query.contentLength,
      },
    });

    if(response.status !== 200 ){
      throw new Error(`PUT: ProfilePhoto: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('PATCH: ProfileUpdate: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const updateNotificationPreferences = async(query: any): Promise<types.IApiHandledResponse> => {
  
  /**
   * TO-DO:
   * - Needs Cognito
   * - can accept a notifications object of booleans
   * - eg {
   *  identifier: true,
   *  productUpdates: false,
   * -    }
   */
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/notification', {
      method: 'PATCH',
      body: JSON.stringify({
        changes: query.body
      })
    });

    if(response.status !== 200 ){
      throw new Error(`PATCH: NotificationsUpdate: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('PATCH: NotificationsUpdate: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const  createGroup  = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    /**
     * TO-DO:
     * - Check with API docs and update to work with UI
     * - can accept user's name, photo, etc
     */
    helpers.logToOutput('API: GROUP: POST: ', query)
    
    const response = await fetch(EXP_LAMBDA_API_URL + '/groups', {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('API: GROUP: POST: ', response)
  
    if(response.status !== 200 ){
      throw new Error(`POST: User: HTTP error! Status: ${response.status}`);
    } else {
        
      const responseJson = await response.json();
      helpers.logToOutput('API: GROUP: POST[JSON]: ', responseJson)
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: Group: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const  getGroups  = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
  
    /**
     * TO-DO:
     * - Check with API docs and update to work with UI
     * - can accept user's name, photo, etc
     */
    const response = await fetch(EXP_LAMBDA_API_URL + '/groups', {
      method: 'GET',
    });

    helpers.logToOutput('API: GROUPS: GET: ', response)
  
    if(response.status !== 200 ){
      throw new Error(`GET: GROUP List: HTTP error! Status: ${response.status}`);
    } else {
      const responseJson = await response.json();
      helpers.logToOutput('API: USERS: GET[JSON]: ', responseJson)
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET: GROUP List: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const  editGroup  = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    /**
     * TO-DO:
     * - Check with API docs and update to work with UI
     * - can accept user's name, photo, etc
     */
    helpers.logToOutput('API: GROUP: EDIT: BODY: ', query)

    const updatedData = {
      ...query.body,
      users: query.body.users.map((user: any) => user.value),
    };
    
    const response = await fetch(EXP_LAMBDA_API_URL + `/groups/group/${query.body.id}`, {
      method: 'PUT',
      body: JSON.stringify(updatedData)
    });

    helpers.logToOutput('API: Group: EDIT: ', response)
  
    if(response.status !== 200 ){
      throw new Error(`EDIT: Group: HTTP error! Status: ${response.status}`);
    } else {
        
      const responseJson = await response.json();
      helpers.logToOutput('API: Group: EDIT[JSON]: ', responseJson)
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('EDIT: Group: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const  delGroup  = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    helpers.logToOutput('API: GROUP: DELETE: BODY: ', query)
    
    const response = await fetch(EXP_LAMBDA_API_URL + `/groups/group/${query.body.id}`, {
      method: 'DELETE',
    });

    helpers.logToOutput('API: GROUP: DELETE: ', response)
  
    if(response.status !== 200 ){
      helpers.logToOutput('DELETE: GROUP: HTTP error: ', response);
      throw new Error(`DELETE: GROUP: HTTP error! Status: ${response.status}`);
    } else {
        
      const responseJson = await response.json();
      helpers.logToOutput('API: GROUP: DELETE[JSON]: ', responseJson)
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('DELETE: GROUP: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const  createUser  = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    /**
     * TO-DO:
     * - Check with API docs and update to work with UI
     * - can accept user's name, photo, etc
     */
    helpers.logToOutput('API: USERS: POST: BODY: ', query)
    
    const response = await fetch(EXP_LAMBDA_API_URL + '/users', {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('API: USERS: POST: ', response)
  
    if(response.status !== 200 ){
      throw new Error(`POST: User: HTTP error! Status: ${response.status}`);
    } else {
        
      const responseJson = await response.json();
      helpers.logToOutput('API: USERS: POST[JSON]: ', responseJson)
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: User: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const  editUser  = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    /**
     * TO-DO:
     * - Check with API docs and update to work with UI
     * - can accept user's name, photo, etc
     */
    helpers.logToOutput('API: USERS: EDIT: BODY: ', query)
    
    const response = await fetch(EXP_LAMBDA_API_URL + `/users/${query.body.id}`, {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('API: USERS: EDIT: ', response)
  
    if(response.status !== 200 ){
      throw new Error(`EDIT: User: HTTP error! Status: ${response.status}`);
    } else {
        
      const responseJson = await response.json();
      helpers.logToOutput('API: USERS: EDIT[JSON]: ', responseJson)
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('EDIT: User: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const  deleteUser  = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    /**
     * TO-DO:
     * - Check with API docs and update to work with UI
     * - can accept user's name, photo, etc
     */
    helpers.logToOutput('API: USERS: DELETE: BODY: ', query)
    
    const response = await fetch(EXP_LAMBDA_API_URL + `/users/${query.body.id}`, {
      method: 'DELETE',
    });

    helpers.logToOutput('API: USERS: DELETE: ', response)
  
    if(response.status !== 200 ){
      throw new Error(`DELETE: User: HTTP error! Status: ${response.status}`);
    } else {
        
      const responseJson = await response.json();
      helpers.logToOutput('API: USERS: DELETE[JSON]: ', responseJson)
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('DELETE: User: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const  getUser  = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    /**
     * TO-DO:
     * - Check with API docs and update to work with UI
     * - can accept user's name, photo, etc
     */
    helpers.logToOutput('API: USERS: DELETE: BODY: ', query)
    
    const response = await fetch(EXP_LAMBDA_API_URL + `/users/${query.body.id}`, {
      method: 'GET',
    });

    helpers.logToOutput('API: USER: GET: ', response)
  
    if(response.status !== 200 ){
      throw new Error(`GET: User: HTTP error! Status: ${response.status}`);
    } else {
        
      const responseJson = await response.json();
      helpers.logToOutput('API: USER: GET[JSON]: ', responseJson)
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET: User: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const  getUsers  = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
  
    /**
     * TO-DO:
     * - Check with API docs and update to work with UI
     * - can accept user's name, photo, etc
     */
    const response = await fetch(EXP_LAMBDA_API_URL + '/users', {
      method: 'GET',
    });

    helpers.logToOutput('API: USERS: GET: ', response)
  
    if(response.status !== 200 ){
      throw new Error(`GET: UserList: HTTP error! Status: ${response.status}`);
    } else {
        
      const responseJson = await response.json();
      helpers.logToOutput('API: USERS: GET[JSON]: ', responseJson)
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson['items']
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET: UserList: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const setAdminControl = async(query: any): Promise<types.IApiHandledResponse> => {
  try {


    const response = await fetch(EXP_LAMBDA_API_URL + `/admin/products/${query.id}/control`, {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    if(response.status !== 200 ){
      throw new Error(`POST: setAdminControl: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: setAdminControl: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const setConfiguration = async(query: any) => {
  helpers.logToOutput('setConfiguration POST Request:', query);
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + '/admin/configuration', {
      method: 'POST',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('setConfiguration response:', response);

    if (!response.ok) {
      throw new Error(`setConfiguration HTTP error! Status: ${response.status}`);
    }

    //const responseJson = await response.json();
    return response

  } catch (error: any) {
    helpers.logToOutput('setConfiguration Error', error.message); // Setting the error state if there's an error
    
  }
}

export const getConfiguration = async(_: any): Promise<types.IApiHandledResponse> => {
  try {
    helpers.logToOutput('GET getConfiguration !');
    const response = await fetch(EXP_LAMBDA_API_URL + '/admin/configuration', {
      method: 'GET',
      // body: JSON.stringify(query.body)
    });
    
    if(response.status !== 200 ){
      helpers.logToOutput('GET getConfiguration Error: ', response); 
      throw new Error(`GET getConfiguration HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: JSON.parse(responseJson.response)
      }
    }
  } catch (error: any) {
    helpers.logToOutput('GET getConfiguration Error', error.message);
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getOpenConfiguration = async(url: string): Promise<types.IApiHandledResponse> => {
  try {
    //helpers.logToOutput('GET getOpenConfiguration !:', url);
    const response = await fetch(url + '/open/configuration', {
      method: 'GET',
      // body: JSON.stringify(query.body)
    });
    
    if(response.status !== 200 ){
      //helpers.logToOutput('GET getOpenConfiguration Error 1: ', response); 
      throw new Error(`GET getOpenConfiguration HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      //helpers.logToOutput('GET getOpenConfiguration responseJson:', responseJson);
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: JSON.parse(responseJson.response)
      }
    }
  } catch (error: any) {
    //helpers.logToOutput('GET getOpenConfiguration Error 2', error.message);
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const postSignalForwardingSetup = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    const response = await fetch(EXP_LAMBDA_API_URL + `/android/${query.body.id}/signal`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({})
    });

    if(response.status !== 200 ){
      throw new Error(`POST: postSignalForwardingSetup: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: postSignalForwardingSetup: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getSignalForwardingSetup = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    helpers.logToOutput('GET getSignalForwardingSetup !');
    const response = await fetch(EXP_LAMBDA_API_URL + `/android/${query.body.id}/signal`, {
      method: 'GET',
    });
    
    if(response.status === 200 ){
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson.response
      }
     
    } else {
      helpers.logToOutput('GET getSignalForwardingSetupFinish Error: ', response); 
      throw new Error(`GET getSignalForwardingFinish HTTP error! Status: ${response.status}`); 
    }
  } catch (error: any) {
    helpers.logToOutput('GET getSignalForwardingSetupFinish Error', error.message);
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const deleteSignalForwardingSetup = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    const response = await fetch(EXP_LAMBDA_API_URL + `/android/${query.body.id}/signal`, {
      method: 'DELETE',
      body: JSON.stringify({})
    });

    if(response.status !== 200 ){
      throw new Error(`DELETE: deleteSignalForwardingSetup: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('DELETE: deleteSignalForwardingSetup: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const getAllLicensing = async(): Promise<types.IApiHandledResponse> => {
  try {
    helpers.logToOutput('GET getAllLicensing !');
    const response = await fetch(EXP_LAMBDA_API_URL + '/licenses/all', {
      method: 'GET',
    });
    
    if (response.status !== 200) {
      helpers.logToOutput('GET getAllLicensing Error: ', response); 
      throw new Error(`GET getAllLicensing HTTP error! Status: ${response.status}`);
    } else {
      const responseJson = await response.json();
      helpers.logToOutput('GET getAllLicensing Info: ', responseJson); 
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      };
    }
  } catch (error: any) {
    helpers.logToOutput('GET getAllLicensing Error', error.message);
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error.message ?? error
    };
  }
}

export const getLicensing = async(): Promise<types.IApiHandledResponse> => {
  try {
    helpers.logToOutput('GET getAllLicensing !');
    const response = await fetch(EXP_LAMBDA_API_URL + '/licenses', {
      method: 'GET',
    });
    
    if (response.status !== 200) {
      helpers.logToOutput('GET getLicensing Error: ', response); 
      throw new Error(`GET getLicensing HTTP error! Status: ${response.status}`);
    } else {
      const responseJson = await response.json();
      helpers.logToOutput('GET getLicensing Info: ', responseJson); 
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      };
    }
  } catch (error: any) {
    helpers.logToOutput('GET getLicensing Error', error.message);
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error.message ?? error
    };
  }
}

export const getLicense = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    const response = await fetch(EXP_LAMBDA_API_URL + `/license/${query.id}/`, {
      method: 'GET'
    });

    if(response.status !== 200 ){
      throw new Error(`POST: postLicense: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: postLicense: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const postNewLicense = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    const response = await fetch(EXP_LAMBDA_API_URL + '/license', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(query.body)
    });

    if(response.status !== 200 ){
      throw new Error(`POST: postNewLicense: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: postNewLicense: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const putUpdateLicense = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    const response = await fetch(EXP_LAMBDA_API_URL + `/license/${query.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(query.body)
    });

    if(response.status !== 200 ){
      throw new Error(`POST: postUpdateLicense: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: postUpdateLicense: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const deleteLicense = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
  
    const response = await fetch(EXP_LAMBDA_API_URL + `/license/${query.id}`, {
      method: 'DELETE'
    });

    if(response.status !== 200 ){
      throw new Error(`POST: deleteLicense: HTTP error! Status: ${response.status}`);
    } else {
      
      const responseJson = await response.json();
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: responseJson
      }
    }
  } catch (error: any) {
    helpers.logToOutput('POST: deleteLicense: Error', error.message); // Setting the error state if there's an error
    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
}

export const putProductUpdateName = async(query: any): Promise<types.IApiHandledResponse> => {
  try {
    const response = await fetch(EXP_LAMBDA_API_URL + `/products/${query.id}/update`, {
      method: 'PUT',
      body: JSON.stringify(query.body)
    });

    helpers.logToOutput('putProductUpdateName response:', response);

    if (response.status !== 200) {
      throw new Error(`putProductUpdateName HTTP error! Status: ${response.status}`);
    } else {

      helpers.logToOutput('putProductUpdateName ResponseJson');
      return {
        status: DEFAULT_API_RESULT.SUCCESS,
        body: {}
      }
    }

  } catch (error: any) {
    helpers.logToOutput('putProductUpdateName Error', error.message); // Setting the error state if there's an error

    return {
      status: DEFAULT_API_RESULT.FAILURE,
      errorMessage: error
    }
  }
  
}